import React from 'react';
import { Button, Result } from 'antd';
import { logApiError } from '../../utils/apiError';
import { captureFrontendException } from '../../config/monitoring';

class ErrorBoundary extends React.Component {
  state = {
    hasError: false,
  };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    logApiError('React error boundary caught an error', { error, info });
    captureFrontendException(error, { componentStack: info.componentStack });
  }

  render() {
    if (this.state.hasError) {
      return (
        <Result
          status="500"
          title="Something went wrong"
          subTitle="Refresh the page or return home to continue shopping."
          extra={[
            <Button key="reload" type="primary" onClick={() => window.location.reload()}>
              Refresh
            </Button>,
            <Button key="home" onClick={() => { window.location.href = '/'; }}>
              Home
            </Button>,
          ]}
        />
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
